import React, { useEffect, useState } from "react";
import { fetchCourseByCourseId } from "../../api/courseApi";
import { buyCourse } from "./../../api/transactionApi";

import Loading from "../common/Loading";
import CourseDetailChapter from "./CourseDetailChapter";
import { Link, useNavigate } from "react-router-dom";
import ToastService from "../../services/ToastService";
import { useSelector } from "react-redux";
import Modal3Js from "../Modal3Js";

const CourseDetail = ({ courseId }) => {
  const [course, setCourse] = useState(null);
  const [isModalBuyOpen, setIsModalBuyOpen] = useState(false);
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const data = await fetchCourseByCourseId({ courseId: courseId, userId: user && user.guid });

      if (data) {
        setCourse(data);
      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const PayCourse = async () => {
    try {
      const data = await buyCourse({
        userId: user && user.guid,
        courseId: courseId,
      });

      setIsModalBuyOpen(false);
      ToastService.Success('Mua khóa học "' + course.title + '" thành công');
    } catch (error) {
      setIsModalBuyOpen(false);
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };

  return (
    <>
      {isModalBuyOpen && (
        <Modal3Js
          isOpen={isModalBuyOpen}
          onClose={() => setIsModalBuyOpen(false)}
          title="🏆 Thông báo"
          submitText="Confirm"
          cancelText="Cancel"
        >
          <p>
            Bạn có muốn mua khóa học{" "}
            <span className="text-yellow-300 font-bold">
              "{course && course.name}"
            </span>{" "}
            này không?
          </p>

          <div className="buttons">
            <div
              onClick={() => {
                PayCourse();
              }}
              data-router-disabled=""
              class="button is-purple"
            >
              <span class="hover"></span>
              <span class="label">Thanh toán</span>
            </div>
            <button
              className="js-close button"
              onClick={() => {
                setIsModalBuyOpen(false);
              }}
            >
              <span className="hover"></span>
              <span className="label">Đóng</span>
            </button>
          </div>
        </Modal3Js>
      )}
      <section className="js-hero hero is-not-interacting clear-selection">
        <div className="mask is-left"></div>

        {course && (
          <>
            <div className="content">
              <div className="top">
                <h1 className="element delay-1 main-title">{course.name}</h1>

                <div className="element delay-2 description">
                  <p>{course.shortDesc}</p>
                </div>

                <span className="element delay-3 separator"></span>
              </div>
            </div>

            <div className="js-experience experience">
              <div className="video">
                {/* <video
                  className="js-video-autoplay"
                  src="https://media.bemamnon.com/NumberBlocks/Level%201%20Numbers%20up%20to%205/Numberblocks_S01E01_One.mp4"
                  autoPlay
                  loop
                  controls
                  width={"80%"}
                  height={"80%"}
                  style={{ borderRadius: "20px" }}
                ></video> */}
                <img src={course.thumbnailUrl} width="90%" alt="" />
              </div>
              <div
                className="join-group"
                style={{ textAlign: "center", marginTop: "50px" }}
              >
                {course && !course.isOwnCourse && (
                  <button
                    onClick={() => {
                      if (!user) {
                        navigate("/login");
                        return;
                      }

                      setIsModalBuyOpen(true);
                    }}
                    className="button is-white is-main-join"
                  >
                    <span className="hover"></span>
                    <span className="label">
                      Mua ngay
                      <br />
                      {course.price} coin
                    </span>
                  </button>
                )}

                <Link
                  to={
                    course.firstLesson &&
                    "/course/" + courseId + "/lessons/" + course.firstLesson.id
                  }
                  className="button is-white is-main-join"
                >
                  <span className="hover"></span>
                  <span className="label">{course.isOwnCourse ? 'Bắt đầu học' : 'Xem thử'}</span>
                </Link>
              </div>
            </div>
          </>
        )}
      </section>
      <CourseDetailChapter courseId={courseId} />
    </>
  );
};

export default CourseDetail;
